import { Audit, AuditStatus } from "@/_models/audit.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-audit-task-card",
    standalone: true,
    imports: [CommonModule, SharedComponentsModule, RouterModule],
    templateUrl: "./audit-task-card.component.html",
    styleUrls: [
        "./audit-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class AuditTaskCardComponent {
    @Input() audit: Audit;
    @Input() isLast: boolean = false;

    constructor(public dateUtils: DateUtils) {}

    getTitle(): string {
        return this.audit.title || "Untitled Audit";
    }

    getDueDate(): Date {
        return this.audit.dueDate;
    }

    getStatus(): string {
        return this.audit.status || AuditStatus.Scheduled;
    }
}
